import React, { useState } from 'react';
import './DeviationList.scss';
import {
  DeviationEventType,
  DeviationType,
  DeviationVisibility,
} from './fetchDeviations';
import Fetch from '../../../../utils/fetch';
import { settings } from '../../../../settings';
import Swal from 'sweetalert2';
import Button from '../../../../components/buttons/Button';
import Input from '../../../../components/inputs/Input';

type DeviationRequest = {
  deviationMessage: string | null;
  parentEventId: number | null;
  deviationEventType: DeviationEventType;
  deviationType: DeviationType;
  deviationVisibilities: DeviationVisibility[];
};

export async function postNewDeviation(
  orderId: string,
  deviation: DeviationRequest
) {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/deviation/v2/${orderId}`,

    body: deviation,
  });

  if (response.ok) {
    return;
  } else {
    throw Error('POST Partner Deviation failed');
  }
}

type DeviationFormProps = {
  orderId: string;
  onSuccess: () => void;
};

const DeviationForm = (props: DeviationFormProps): JSX.Element => {
  const init: DeviationRequest = {
    deviationEventType: 'OPEN',
    deviationMessage: '',
    deviationType: 'OTHER',
    deviationVisibilities: ['INTERNAL'],
    parentEventId: null,
  };
  const [requestPayload, setRequestPayload] = useState<DeviationRequest>(init);

  const updateType = (type: DeviationType) => {
    setRequestPayload(ps => ({ ...ps, deviationType: type }));
  };

  const updateSenderVisibility = (visible: boolean) => {
    if (visible) {
      setRequestPayload(ps => ({
        ...ps,
        deviationVisibilities: ['INTERNAL', 'EXTERNAL'],
      }));
    } else {
      setRequestPayload(ps => ({ ...ps, deviationVisibilities: ['INTERNAL'] }));
    }
  };

  const submitForm = (e: React.FormEvent) => {
    e.preventDefault();
    postNewDeviation(props.orderId, requestPayload)
      .then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Deviation submitted',
          showConfirmButton: false,
          timer: 1500,
        }).then(props.onSuccess);
        setRequestPayload(init);
      })
      .catch(() => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Unable to submit deviation',
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  return (
    <form className={'createDeviationForm'} onSubmit={submitForm}>
      <h6>Deviation type:</h6>
      <div>
        <input
          type="radio"
          id="other"
          name="deviationType"
          value="OTHER"
          checked={requestPayload.deviationType === 'OTHER'}
          onChange={_ => updateType('OTHER')}
        />
        <label htmlFor="other">Other</label>
        <input
          type="radio"
          id="notHome"
          name="deviationType"
          value="NOT_HOME"
          onChange={_ => updateType('NOT_HOME')}
        />
        <label htmlFor="notHome">Not home</label>
        <input
          type="radio"
          id="cantFindAddress"
          name="deviationType"
          value="CANT_FIND_ADDRESS"
          onChange={_ => updateType('CANT_FIND_ADDRESS')}
        />
        <label htmlFor="cantFindAddress">Can't find address</label>
        <input
          type="radio"
          id="notInCar"
          name="deviationType"
          value="NOT_IN_CAR"
          onChange={_ => updateType('NOT_HOME')}
        />
        <label htmlFor="notInCar">Not in car</label>
        <input
          type="radio"
          id="damaged"
          name="deviationType"
          value="DAMAGED"
          onChange={_ => updateType('DAMAGED')}
        />
        <label htmlFor="damaged">Damaged</label>
      </div>
      <h6>Visibility</h6>
      <label htmlFor="external">
        <input
          type={'checkbox'}
          id={'external'}
          checked={requestPayload.deviationVisibilities.includes('EXTERNAL')}
          onChange={event => updateSenderVisibility(event.target.checked)}
        />
        Deviation is visible for sender
      </label>
      <h6>Message:</h6>
      <Input
        value={requestPayload.deviationMessage}
        onChange={event =>
          setRequestPayload({
            ...requestPayload,
            deviationMessage: event.target.value,
          })
        }
      />
      <Button title={'Submit'} type={'primary'} />
    </form>
  );
};

export default DeviationForm;
